

class StringHelper {
	/**
	 * @param {String} string
	 * @returns {String}
	 */
	static capitalize(string) {

		if (typeof string !== 'string') {
			throw new TypeError('You can only capitalize strings, ' + typeof string + ' given');
		}

		if (string.length === 0) {
			return '';
		}

		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	/**
	 * @param {String} string
	 * @returns {String}
	 */
	static removeTags(string) {

		if (typeof string !== 'string') {
			throw new TypeError('You can only capitalize strings, ' + typeof string + ' given');
		}

		if (string.length === 0) {
			return '';
		}

		return string.replace(/<\/?[^>]+>/g, '');

	}
}

export default StringHelper;
